<template>
  <f7-page class="nutritional-monitoring-page">
    <div v-if="loaded" class="main-offer-card">
      <div class="summary-header">
        <div class="summary-title">
          <div class="summary-icon-offers"></div>
          <div class="summary-text">{{ $t('offersDetails') }}</div>
        </div>
      </div>
      <OfferListSummary />
      <br />
      <div v-if="!isQCA">
        <div v-if="showDetailsAnalytics" class="margin-bottom">
          <OfferListTableDetails :store="showDetailsAnalytics" />
        </div>
        <div
          v-if="!isQMT && showDetailsNoAnalytics"
          class="custom-table-container-qsp tableContainerQSP margin-bottom"
        >
          <OfferListTableDetailsNoAnalytics
            :store="detailsNoAnalytics"
          />
        </div>
      </div>
      <div class="custom-tab-wrapper">
        <DxTabPanel
          v-if="isQCA"
          class="tableContainer margin-bottom"
          :selected-index="selectedIndex"
          :data-source="tabsConfig"
          :loop="false"
          :animation-enabled="true"
          :swipe-enabled="false"
          @optionChanged="setSelectedIndex"
        >
          <template #title="{ data }">
            <span class="tab-title">{{ data.text }}</span>
          </template>

          <template #item="{ data }">
            <div>
              <div v-if="data.selectedIndex === 1">
                <OfferListTableDetails
                  v-if="isQCA && showDetailsAnalytics"
                  :store="showDetailsAnalytics"
                />
              </div>

              <div v-if="data.selectedIndex === 2">
                <OfferListTableDetailsPntsPts
                  v-if="isQCA && ShowDetailsPNT"
                  :store="ShowDetailsPNT"
                />
              </div>

              <div v-if="data.selectedIndex === 3">
                <OfferListTableDetailsNoAnalytics
                  v-if="isQCA && showDetailsNoAnalytics"
                  :store="detailsNoAnalytics"
                />
              </div>
            </div>
          </template>
        </DxTabPanel>
      </div>
    </div>
    <div class="margin-top">
      <NotificationPricesOffers
        v-if="priceAlert"
        id="notificationPrices"
      />
    </div>
  </f7-page>
</template>
<script>
import OfferListSummary from '@/components/OffersList/OfferListSummary/index.vue';
import OfferListTableDetails from '@/components/OffersList/OfferListDetails/OfferListTableDetails.vue';
import OfferListTableDetailsPntsPts from '@/components/OffersList/OfferListDetails/OfferListTableDetailsPntsPts.vue';
import { mapState, mapActions } from 'vuex';
import NotificationPricesOffers from '@/components/NotificationPrices/NotificationPricesOffers.vue';
import { NOTIFY_TIME_LONG } from '@/js/constants';
import OfferListTableDetailsNoAnalytics from '@/components/OffersList/OfferListDetails/OfferListTableDetails.NoAnalytics.vue';
import { DxTabPanel } from 'devextreme-vue/tab-panel';
import helpers from '@/js/helpers';

export default {
  components: {
    OfferListSummary,
    OfferListTableDetails,
    NotificationPricesOffers,
    OfferListTableDetailsNoAnalytics,
    OfferListTableDetailsPntsPts,
    DxTabPanel,
  },
  data() {
    return {
      loaded: false,
      detailsAnalytics: null,
      detailsNoAnalytics: null,
      showDetailsPNT: null,
      selectedIndex: 0,
      selectedRoute: 0,
      priceAlert: false,
      noAnalytics: this.$t('noAnalytics'),
    };
  },
  computed: {
    urlName() {
      if (this.lastRouteGeotoolboxSamples) {
        return 'GisActionsPage';
      }
      this.get_empresas_centro_produccion();
      return this.lastRouteHome ? 'Home' : 'offersList';
    },
    ShowDetailsPNT() {
      const showDetailsPNTFiltered = this.detallesPresupuestos.filter(
        (detalle) =>
          detalle.DesglosePresupuestoAbierto !== null &&
          detalle.DesglosePresupuestoAbierto.length > 0
      );
      const detallesAplanados = showDetailsPNTFiltered.flatMap(
        (detalle) =>
          detalle.DesglosePresupuestoAbierto.map((item) => ({
            ...item,
            CodPlantaCentroProduccionSeleccionado:
              detalle.CodPlantaCentroProduccionSeleccionado,
          }))
      );
      this.setSubFamilias(detallesAplanados);
      const onlyOneSubFamilia = detallesAplanados.filter(
        (detalle) => {
          return (
            !this.tipoMuestras[0] ||
            detalle.SubfamiliaTM === this.tipoMuestras[0]
          );
        }
      );
      const pntsCompletos = onlyOneSubFamilia.map((detalle) => {
        const empresa = this.centroProduccion.filter(
          (e) =>
            e.CodPlanta ===
            detalle.CodPlantaCentroProduccionSeleccionado
        );
        return {
          ...detalle,
          centroProduccion: empresa,
          PrecioBrutoCodDivisa: `${detalle.Precio} ${this.offerCurrency}`,
        };
      });
      const padres = pntsCompletos.filter(
        (detalle) => detalle.idPNT !== null
      );
      const hijos = pntsCompletos.filter(
        (detalle) => detalle.idPNT === null && detalle.IdPnt !== null
      );
      const pntsOrdenados = [];
      padres.forEach((padre) => {
        pntsOrdenados.push(padre);
        const hijosDelPadre = hijos.filter(
          (hijo) => hijo.IdPnt === padre.idPNT
        );
        pntsOrdenados.push(...hijosDelPadre);
      });
      this.setPriceAlert();
      return pntsOrdenados;
    },
    showDetailsAnalytics() {
      return this.detailsAnalytics;
    },
    offerCurrency() {
      return (
        this.normalizeCurrency(
          this.detallesPresupuestosSummary?.ConversionX3
        ) ||
        this.normalizeCurrency(
          this.detallesPresupuestosSummary?.CodDivisa
        ) ||
        this.normalizeCurrency(this.divisa) ||
        'EUR'
      );
    },
    tabsConfig() {
      const tabsConfig = [
        {
          id: 0,
          text: this.$t('packAnalytical'),
          selectedIndex: 1,
        },
      ];
      tabsConfig.push({
        id: 1,
        text: this.$t('alert.parameters'),
        selectedIndex: 2,
      });
      if (this.showDetailsNoAnalytics) {
        tabsConfig.push({
          id: 2,
          text: this.$t('noAnalytics'),
          selectedIndex: 3,
        });
      }
      return tabsConfig;
    },
    ...mapState('Offers', [
      'detallesPresupuestos',
      'isQCA',
      'isQMT',
      'centroProduccion',
      'detallesPresupuestosSummary',
      'divisa',
      'analisisTipoDescrip',
      'detailsNoAnalyticsDescro',
    ]),
    ...mapState('OffersListFilters', ['tipoMuestras']),
    ...mapState('filter', ['currentSampleId']),
    ...mapState('samples', [
      'lastRouteHome',
      'lastRouteGeotoolboxSamples',
    ]),
  },
  beforeMount() {
    this.setCurrentRoute([
      {
        name: this.$t('offersDetails'),
        disabled: false,
        page: 'offersDetails',
        active: true,
      },
    ]);
    this.setCurrentFilter('offersDetails');
  },
  async mounted() {
    try {
      this.$f7.preloader.show();
      await this.buildAnalyticsDetails();
      await this.showDetailsNoAnalytics();
      this.applyCurrentFilters();
    } catch (error) {
      this.$notifyDX(
        {
          message: this.$t(
            this.$helpers.getFilteredErrorMessage(error)
          ),
          width: 550,
        },
        'error',
        NOTIFY_TIME_LONG
      );
    } finally {
      this.$f7.preloader.hide();
      this.loaded = true;
    }
  },
  methods: {
    async buildAnalyticsDetails() {
      const analyticsDetails = this.detallesPresupuestos.filter(
        (detalle) =>
          detalle.ATanalitico === true &&
          detalle.DesglosePresupuestoAbierto === null
      );

      const sortedDetails = [...analyticsDetails].sort((a, b) => {
        if (a.IdFamilia !== b.IdFamilia) {
          return a.IdFamilia - b.IdFamilia;
        }
        if (
          a.CodPlantaCentroProduccionSeleccionada !==
          b.CodPlantaCentroProduccionSeleccionada
        ) {
          return (
            a.CodPlantaCentroProduccionSeleccionada || ''
          ).localeCompare(
            b.CodPlantaCentroProduccionSeleccionada || ''
          );
        }
        return a.IdSubFamilia - b.IdSubFamilia;
      });

      const atMap = new Map();
      let lastCombinationKey = null;
      const codigoClientePresupuesto =
        this.detallesPresupuestosSummary?.CodCliente;

      for (const item of sortedDetails) {
        const codPlanta =
          item.CodPlantaCentroProduccionSeleccionada || '';
        const combinationKey = `${codPlanta}|${item.IdFamilia}|${item.IdSubFamilia}`;

        if (combinationKey !== lastCombinationKey) {
          lastCombinationKey = combinationKey;

          await this.fetchAnalisisTipo({
            codPlanta,
            idFamiliaTM: item.IdFamilia,
            idSubFamiliaTM: item.IdSubFamilia,
            codCliente: codigoClientePresupuesto,
            codIdioma: null,
          });

          (this.analisisTipoDescrip || []).forEach((analisis) => {
            if (
              analisis?.CodArticulo &&
              !atMap.has(analisis.CodArticulo)
            ) {
              atMap.set(analisis.CodArticulo, analisis);
            }
          });
        }
      }

      this.detailsAnalytics = sortedDetails.map((detalle) => {
        const analisis = atMap.get(detalle.CodArticulo);

        return {
          ...detalle,
          DescripcionAT:
            detalle.IdSubFamiliaTM === 63
              ? analisis?.CodAnalisisTipo ?? detalle.DescripcionAT
              : analisis?.DescripcionAT ?? detalle.DescripcionAT,
          PrecioNetoCodDivisa: `${detalle.PrecioBruto} ${this.offerCurrency}`,
        };
      });

      return this.detailsAnalytics;
    },
    async showDetailsNoAnalytics() {
      try {
        await this.setDetailsNoAnalytics(
          this.detallesPresupuestos.filter(
            (detalle) => detalle.ATanalitico === false
          )
        );
        await this.obtenerDescripcionNoAnalytics(
          this.detailsNoAnalyticsDescro[0].IdFamilia,
          this.detailsNoAnalyticsDescro[0].IdSubFamilia
        );
        const detallesFiltrados = this.detailsNoAnalyticsDescro
          .filter((detalle) => detalle.ATanalitico === false)
          .map((detalle) => {
            const analisis = this.analisisTipoDescrip.find(
              (a) => a.AnalisisTipo === detalle.CodArticulo
            );
            return {
              ...detalle,
              PrecioNetoCodDivisa: `${detalle.PrecioBruto} ${this.offerCurrency}`,
              descripcion: analisis
                ? analisis.CodAnalisisTipo
                : undefined,
            };
          });
        this.detailsNoAnalytics = detallesFiltrados;
        return this.detailsNoAnalytics.length > 0
          ? this.detailsNoAnalytics
          : false;
      } catch {
        return false;
      }
    },
    async obtenerDescripcionNoAnalytics(idFamilia, idSubFamilia) {
      await this.fetchAnalisisTipo({
        codPlanta: null,
        idFamiliaTM: idFamilia,
        idSubFamiliaTM: idSubFamilia,
        codCliente: null,
        codIdioma: null,
      });
      return this.detailsNoAnalyticsDescro;
    },
    normalizeCurrency(currency) {
      return helpers.normalizeMonetaryUnit(currency);
    },
    setSelectedIndex(e) {
      if (e.name === 'selectedIndex') {
        this.selectedRoute = e.value;
      }
    },
    setPriceAlert() {
      this.priceAlert = true;
    },
    ...mapActions('breadcrumb', ['setCurrentRoute']),
    ...mapActions('filter', [
      'setCurrentFilter',
      'applyCurrentFilters',
    ]),
    ...mapActions('Offers', [
      'get_empresas_centro_produccion',
      'setSubFamilias',
      'fetchAnalisisTipo',
      'setDetailsNoAnalytics',
    ]),
  },
};
</script>
<style lang="scss">
@import './offers-details-page.Styles.scss';
</style>
